import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FloatLabelType } from '@angular/material/form-field';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { CustomizationFrameworkService } from '../../../../shared-modules/customization-framework/customization-framework.service';
import { LoginService } from '../../../../shared-modules/login/login.service';
import { YearService } from '../../../year/year.service';
import { DataDefControl } from '../data-def-control.directive';

@AutoUnsubscribe({ includeArrays: true })
@Component({
    selector: 'data-def-dropdown',
    templateUrl: './data-def-dropdown.component.html',
    styleUrls: ['./data-def-dropdown.component.css']
})
export class DataDefDropdownComponent extends DataDefControl {

    @Input() floatLabel: FloatLabelType;
    @Input() hintLabel: string;
    @Input() hintColor: string;
    @Input() clearable: boolean;
    @Input() preventCollapse: boolean;
    @Input() postLabelSpace: boolean;
    @Input() fullWidth: boolean;

    private _controlRef: ElementRef;
    get controlRef() {
        return this._controlRef;
    }
    @ViewChild('control', { read: ElementRef }) set controlRef(value: ElementRef) {
        this._controlRef = value;
        this.controlEmitter.emit(value);
    }

    constructor(
        customizationFrameworkService: CustomizationFrameworkService,
        yearService: YearService,
        loginService: LoginService
    ) {
        super(customizationFrameworkService, yearService, loginService);
    }
}
